import $ from 'jquery';

class CollapseScrollTop {
    constructor(el) {
        this.DOM = {el: el};
        this.DOM.targetSelector = this.DOM.el.dataset.scrollTarget;
        this.DOM.scrollTarget = document.querySelector(this.DOM.targetSelector) || this.DOM.el;

        this.offset = this.DOM.el.dataset.collapseScrollTop || 250

        this.initEvents();
    }

    initEvents() {
        /* Listen for collapse close */
        $(this.DOM.el).on('hide.bs.collapse', () => {
            /* Smooth scroll to the scroll target of collapse element */
            $('html, body').animate({
                scrollTop: $(this.DOM.scrollTarget).offset().top - this.offset,
            }, 350);
        })
    }
}

const collapseNodes = Array.from(document.querySelectorAll('[data-collapse-scroll-top]'));
if (collapseNodes !== null) {
    collapseNodes.forEach((collapse) => { new CollapseScrollTop(collapse); })
}
